var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTroubleShootingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7279_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.32 24L16.68 18.0632C15.86 18.7368 14.955 19.2632 13.965 19.6421C12.975 20.0211 11.92 20.2105 10.8 20.2105C9 20.2105 7.375 19.7474 5.925 18.8211C4.475 17.8947 3.33 16.6737 2.49 15.1579H5.43C6.11 15.9368 6.905 16.5526 7.815 17.0053C8.725 17.4579 9.72 17.6842 10.8 17.6842C12.8 17.6842 14.5 16.9474 15.9 15.4737C17.3 14 18 12.2105 18 10.1053C18 8 17.3 6.21053 15.9 4.73684C14.5 3.26316 12.8 2.52632 10.8 2.52632C8.92 2.52632 7.295 3.19474 5.925 4.53158C4.555 5.86842 3.79 7.51579 3.63 9.47368H1.23C1.39 6.8 2.385 4.55263 4.215 2.73158C6.045 0.910526 8.24 0 10.8 0C13.48 0 15.75 0.978947 17.61 2.93684C19.47 4.89474 20.4 7.28421 20.4 10.1053C20.4 11.2842 20.22 12.3947 19.86 13.4368C19.5 14.4789 19 15.4316 18.36 16.2947L24 22.2316L22.32 24ZM9.51 15.1579L7.62 8.58947L6.06 13.2632H0V11.3684H4.8L6.78 5.36842H8.58L10.41 11.8105L11.7 7.57895H13.5L15.3 11.3684H16.2V13.2632H14.19L12.78 10.2947L11.28 15.1579H9.51Z",
    fill: "#E8EAED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7279_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleShootingIcon);
export default __webpack_public_path__ + "static/media/TroubleShootingIcon.ca6235dfa3493a621ce2238fcb4742ec.svg";
export { ForwardRef as ReactComponent };